const EventDetailsPlaceholder = () => {
  return (
    <div className="container mx-auto px-8 pb-8 pt-12">
      <div className="w-full max-w-2xl mx-auto md:mx-0 h-10 mb-4 bg-gray-300 animate-pulse rounded" />

      <div className="flex flex-col md:flex-row justify-center md:justify-start items-center md:gap-8">
        <div className="flex items-center gap-2 mb-4 md:mb-0">
          <div className="w-6 h-6 bg-gray-300 animate-pulse rounded" />
          <div className="flex flex-col gap-1">
            <div className="w-32 h-4 bg-gray-300 animate-pulse rounded" />
            <div className="w-32 h-4 bg-gray-300 animate-pulse rounded" />
          </div>
        </div>

        <div className="hidden md:block w-[2px] h-8 bg-gray-300 animate-pulse" />

        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-gray-300 animate-pulse rounded" />
          <div className="flex flex-col gap-1">
            <div className="w-40 h-4 bg-gray-300 animate-pulse rounded" />
            <div className="w-32 h-4 bg-gray-300 animate-pulse rounded" />
          </div>
        </div>
      </div>

      <div className="w-6/12 h-20 mt-6 bg-gray-300 animate-pulse rounded" />
    </div>
  )
}

export { EventDetailsPlaceholder }
